import React, { useContext, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'reactstrap';
import { useHistory } from "react-router-dom";
// import LanguageToggle from 'views/Forms/Private/LanguageToggle';
import {
  Button,
  Row,
  Col,
  FormGroup, FormControl, FormLabel
} from "react-bootstrap";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SweetAlert from "react-bootstrap-sweetalert";
import baolin_art2 from '../../../assets/img/baolinPrivate/baolin_art2.png';
import baolin_art3 from '../../../assets/img/baolinPrivate/baolin_art3.png';
import lianghuang from '../../../assets/img/baolinPrivate/2025lianghuang.png';
import { GuestContext } from "../../../contexts/GuestContext";

function SliderArrowNext(props) {
  const { className, onClick } = props;


  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  );
}

function SliderArrowPrev(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  );
}


export default function LivePreviewExample() {
  const history = useHistory();
  const [alert, setAlert] = React.useState(null);
  const { language, setPageBanner } = useContext(GuestContext);
  useEffect(() => {
    setPageBanner(2);
  }, [setPageBanner]); // Dependencies array

  const handleRegisterClick = () => {
    history.push('/register');
  };

  const slide1 = (<>
    <div>
      <a
        href="#/"
        onClick={(e) => e.preventDefault()}
        className="card m-3 shadow-sm-dark card-box-hover-rise">
        <img src={lianghuang} className="card-img-center" alt="..." />
        <div className="p-3 .bg-white-5 rounded-bottom p-xl-4">
          <div className="flex-column flex-sm-row justify-content-between block">
            <h5 className="font-weight-bold font-size-lg text-second mb-0 ">
              {language === "Chinese" ? "2025梁皇寶懺精進共修" : "2025 Liang Huang Jeweled Repentance Weekly Sunday Service"}
            </h5>
            <h6 className="font-weight-bold font-size-lg text-second mb-1 mt-1 block">
              {language === "Chinese" ? "5月11日 ~ 8月10日 (共10次共修)" : "11/5/2026 ~ 10/8/2025 (10 Services)"}
            </h6>
          </div>
          <div>
            <Badge className="mr-1 text-white block" color="info" style={{ fontSize: '0.9em' }}>
              {language === "Chinese" ? "下一次共修：2025年5月11日" : "Next Event: May 11th, 2025"}
            </Badge>
          </div>
          <Badge className="mr-1 text-white block" color="success" style={{ fontSize: '0.9em' }}>
            {language === "Chinese" ? "上午 9:30 ～ 中午 12:30 卷一" : "Session 1: 9:30AM ～ 12:30PM Scroll 1"}
          </Badge>
          {/* <Badge className="mr-1 text-white block" color="success" style={{ fontSize: '0.9em' }}>
            {language === "Chinese" ? "下午 13:30 ～ 下午 16:00 卷二" : "Session 2: 13:30PM ～ 16:00PM Scroll 2"}
          </Badge> */}

          <p className="text-second opacity-8 mt-4 mb-4">
          <p className="text-second opacity-8 mt-4 mb-4">
          <p className="text-second opacity-8 mt-4 mb-4">
          {language === "Chinese" ? (
    <>
      <p className='font-weight-bold mb-3'>
      8月10日共修圓滿日將舉行消災、超薦暨總回向法會，將精進共修功德，回向四恩、法界有情。歡迎大眾登記消災、超薦牌位，祈願陽上親友與歷代先亡，同霑法益，共證菩提。
      </p>
      {/* <ul style={{ listStyle: 'none', padding: 0 }}>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 佛法開示 Dharma Talk</li>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 浴佛大典 Buddha Bathing Ceremony</li>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 佛前大供 Grand Meal Offering to Buddhas</li>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 菩提素齋 Lunch</li>
      </ul> */}
    </>
  ) : (
    <>
      <p className='font-weight-bold mb-3'>
      The Blessing and Memorial Services will be held on the day of the completion ceremony. We will dedicate all merits from the diligence of chanting to repay the four kindness (of parents, sentient beings, the country and the Three Jewels). Everyone is welcome to register tablet(s) for your family and/or friends, wishing all to attain enlightenment.
      </p>
      {/* <ul style={{ listStyle: 'none', padding: 0 }}>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 佛法開示 Dharma Talk</li>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 浴佛大典 Buddha Bathing Ceremony</li>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 佛前大供 Grand Meal Offering to Buddhas</li>
        <li style={{ marginBottom: '5px', paddingLeft: '20px' }}>• 菩提素齋 Lunch</li>
      </ul> */}
    </>
  )}

</p>

</p>

</p>

          <Row>
            <Col>
              <Button
                className="btn-round btn-wd mr-1 "
                style={{ fontWeight: 'bold' }}
                href="#/"
                type="button"
                variant="warning"
                size="md"
                outline
                block
                onClick={handleRegisterClick}
              >
                {language === "Chinese" ? "我要報名" : "Register"}
              </Button>
            </Col>
          </Row>
        </div>
      </a>

    </div>
  </>)

  const slides = [slide1]

  const widgetsCarousels4A = {
    dots: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
    infinite: slides.length >= 2,
    responsive: [
      {
        breakpoint: 1450,
        settings: { slidesToShow: 3, slidesToScroll: 1 }
      },
      {
        breakpoint: 1100,
        settings: { slidesToShow: 2, slidesToScroll: 1 }
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 1, slidesToScroll: 1 }
      }
    ]
  };


  return (
    <>
      {/* <Card className="bg-night-sky py-4"> */}
      <div className="py-0">
        <Slider
          className="rounded-lg overflow-hidden slider-arrows-outside slider-dots-outside slider-dots-light"
          {...widgetsCarousels4A}>
          {slides[0]}
        </Slider>
      </div>
      {/* </Card> */}
      {alert}
    </>
  );
}
